import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { API_URL } from "../config";

/**
 * ─── Login Page ───
 *
 * Works for both admins and members.
 * After login, admins see the Admin link, members get auto-fill on bookings.
 */

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch(`${API_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ username, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || "Noe gikk galt");
        return;
      }

      // Cookie is set by the server — update React state with role info
      login(data.username, data.role, data.email, data.name, data.sex, data.age);

      // Redirect based on role
      if (data.role === "admin") {
        navigate("/admin");
      } else {
        navigate("/");
      }
    } catch (err) {
      setError("Kan ikke koble til serveren. Er den startet?");
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
      <div className="card shadow" style={{ width: "400px" }}>
        <div className="card-body p-4">
          <h3 className="card-title text-center mb-4">🔐 Logg inn</h3>

          {error && <div className="alert alert-danger">{error}</div>}

          <form onSubmit={handleSubmit} noValidate>
            <div className="mb-3">
              <label htmlFor="login-username" className="form-label">Brukernavn</label>
              <input
                id="login-username"
                type="text"
                className="form-control"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="login-password" className="form-label">Passord</label>
              <input
                id="login-password"
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
            </div>
            <button type="submit" className="btn btn-primary w-100 mb-3">
              Logg inn
            </button>
          </form>

          <p className="text-center mb-2">
            <a href="/forgot-password" className="text-decoration-none text-muted">Glemt passord?</a>
          </p>

          <p className="text-center text-muted mb-0">
            Ikke medlem ennå?{" "}
            <a href="/signup" className="text-decoration-none">Registrer deg</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
